import React from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { BrandButton as Button } from "@/components";
import SafeLocalStorage from "@/utils/safeLocalStorage";
import { STORAGE_KEYS } from "@/constants/storage";

export default function Logout() {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const handleLogout = async () => {
    try {
      console.log("Starting logout process...");
      
      // Clear our app's localStorage
      SafeLocalStorage.remove(STORAGE_KEYS.AUTH_SESSION);
      SafeLocalStorage.remove(STORAGE_KEYS.WELCOME_MESSAGE);
      console.log("Cleared auth session and welcome message from localStorage");
      
      // Use MSAL's logoutRedirect to properly sign out from Azure AD
      // This clears MSAL cache AND signs out from Azure AD
      await instance.logoutRedirect({
        account: accounts[0],
        postLogoutRedirectUri: window.location.origin, // Redirects to your app's home page
      });
      
      // Note: Code after logoutRedirect won't execute as it redirects away
    } catch (error) {
      console.error("Logout error:", error);
      // Fallback: clear local state and navigate
      sessionStorage.clear();
      navigate("/");
    }
  };

  return (
    <Button
      onClick={handleLogout}
      size="large"
      style={{ 
        fontSize: "1.7rem", 
        whiteSpace: "nowrap",
        minWidth: "fit-content"
      }}
    >
      Logout
    </Button>
  );
}
